/** Policy Directus « Générateur de badges » (créée avec cet identifiant par `provision-badge-directus.mjs`). */
export const BADGE_POLICY_ID = '9a1e41bc-d7e7-4188-9e50-4a0cc212e496'
